import { Typography } from '@mui/material';

export const TableEmptyState = () => (
  <Typography
    sx={{
      color: 'content.secondary',
      width: '100%',
      textAlign: 'center',
      mt: 5,
    }}
  >
    There are no results to display
  </Typography>
);
